export * from "./vipps-start.component";